import * as React from "react"
import { Link } from "gatsby"
import * as s from "./Footer.module.css"

/**
 * The footer, on every page — MTC-FCS-046.
 * ============================================================================
 * Added once, in `wrapPageElement` (gatsby-browser.js and gatsby-ssr.js), not
 * pasted into fifteen page files. A footer that has to be remembered is a
 * footer that is missing from whichever page was written last.
 *
 * ── IT IS NOT ON THE GENERATED SITES ───────────────────────────────────────
 * A contractor's published page has its own footer, built from their business
 * details. This one belongs to freecontractorservices.com and would be a
 * stranger's branding on somebody else's website.
 *
 * ── data-print="hide" ──────────────────────────────────────────────────────
 * The invoice builder prints to PDF, and a site footer on page two of an
 * invoice is how a tool stops looking professional.
 */

const YEAR = new Date().getFullYear()

const TOOLS = [
  { to: "/website-builder", label: "Website builder" },
  { to: "/invoice-builder", label: "Invoice builder" },
  { to: "/qr-codes", label: "QR codes" },
]

const ACCOUNT = [
  { to: "/log-in", label: "Log in" },
  { to: "/sign-up", label: "Create an account" },
  { to: "/account", label: "Your account" },
]

const HELP = [
  { to: "/website", label: "How it works" },
  { to: "/help/cannot-log-in", label: "Cannot log in?" },
]

const Column = ({ title, links }) => (
  <nav className={s.column} aria-label={title}>
    <h2 className={s.columnTitle}>{title}</h2>
    <ul className={s.links}>
      {links.map(link => (
        <li key={link.to}>
          <Link to={link.to}>{link.label}</Link>
        </li>
      ))}
    </ul>
  </nav>
)

const Footer = () => (
  <footer className={s.footer} data-print="hide">
    <div className="container">
      <div className={s.grid}>
        <div className={s.brandBlock}>
          <Link to="/" className={s.brand}>
            <span className={s.mark} aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M12 3 2 11h3v9h6v-6h2v6h6v-9h3z" />
              </svg>
            </span>
            Free Contractor Services
          </Link>
          <p className={s.blurb}>
            Websites, invoices and QR codes for contractors. Free to build — you only pay if you
            want us to host it.
          </p>
        </div>

        <Column title="Tools" links={TOOLS} />
        <Column title="Account" links={ACCOUNT} />
        <Column title="Help" links={HELP} />
      </div>

      <div className={s.base}>
        <p>© {YEAR} Free Contractor Services</p>
        <p className={s.note}>Built for trades. No contracts, cancel any time.</p>
      </div>
    </div>
  </footer>
)

export default Footer
